import { isFlyin } from '@/src/utils/generalUtils/isFlyin'

export const SELFCARE_BASE = '/communication/selfcare/api'
export const FLYIN_BFF_BASE = '/bff/orbit/v1/communication/selfcare/api'

interface TripRequestContext {
    chnl?: string
    account?: string
}

export const isFlyinContext = (chnl?: string) => isFlyin() || chnl === 'Fly'

export const getTripApiBase = (chnl?: string) => (isFlyinContext(chnl) ? FLYIN_BFF_BASE : SELFCARE_BASE)

export const buildFlyinQuerySuffix = (chnl?: string, recordType?: string) => {
    if (chnl !== 'Fly') return ''
    const safeRecordType = recordType || 'F'
    const searchParams = new URLSearchParams({
        chnl: 'Fly',
        recordType: safeRecordType
    })
    return `?${searchParams.toString()}`
}

export const getFetchControlHeader = ({ chnl, account }: TripRequestContext) => {
    if (isFlyinContext(chnl) && account === 'LINKED') {
        return { 'fetch-control': 'LINKED' }
    }
    return undefined
}

export const getLanHeader = (locale?: string) => ({
    lan: locale?.toLowerCase().startsWith('ar') ? 'AR' : 'EN'
})
